import useForm from "@casino/legacy/client/hooks/form/useForm";
import useDidMount from "@casino/legacy/client/hooks/lifecycle/useDidMount";
import { removeCookie } from "@workspace/cookies/browser";

const useSocialLoginView = () => {
  const { required, watch } = useForm<{ otp?: string }>();
  const { otp } = watch();

  useDidMount(() => {
    removeCookie("social_auth_type");
  });

  return { required, otp };
};

export default useSocialLoginView;
